import type { IHeroBanner } from '~/components/widget/hero-banner/types'

export const heroBanner: IHeroBanner = {
  heading: 'Депозиты в Кыргызстане',
  text: 'Депозиты в Кыргызстане',
  image: '/images/photostock/deposits.png'
}

export default {
  heroBanner
}
